<div class="flex-shrink-0 p-3 theme-bg-color">
  <div class="logo-img">
    <img src="/assets/logo-tyre-buzzar-long.png" alt="Tyre Buzzar Logo" (click)="redirectToHome()" class="cursor-pointer" />
  </div>
  <div class="profile-img">
    <img src="https://axivise-images.s3.ap-south-1.amazonaws.com/app/blank-profile-picture.png" alt="Profile"
      class="rounded-circle" />
    </div>
    <div class="text-center text-truncate">
      {{ userDetailsData?.name }}
    </div>
    <div class="vertical-scrollable">
      @if (!authService.isAdmin()) {
        <ul class="list-unstyled ps-0 mb-0">
          <li class="mb-1">
            <div class="menu-row d-flex align-items-center"(click)="toggleMenu('stockSummary')">
              <span class="menu-row"></span>
              <span class="heading-text stock" [ngClass]="{ 'active': activeItem === 'stockSummary' }" (click)="redirectToHome()" #collapse data-menu="stockSummary"
                >&nbsp;Stock Summary
              </span>
            </div>
            <div class="collapse" id="stock-summary-collapse">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                <li>
                  <a [routerLink]="'/home'" routerLinkActive="active" class="heading-text rounded" [ngClass]="{ 'active': activeItem === 'home' }">
                    View Stock Summary
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      }
      @if (!authService.isAdmin()) {
        <ul class="list-unstyled ps-0" >
          <li class="mb-1">
            <div class="menu-row d-flex align-items-center">
              <span class="menu-row"></span>
              <span [routerLink]="'/day-book'" routerLinkActive="active" class="heading-text" style="cursor: pointer;"
              #collapse data-menu="day-book">&nbsp;Day Book</span>
            </div>
          </li>
          <li class="mb-1">
            <div class="menu-row d-flex align-items-center">
              <span class="menu-row"></span>
              <span [routerLink]="'/expenses'" routerLinkActive="active" class="heading-text" style="cursor: pointer;" #collapse
              data-menu="day-book">&nbsp;Expenses</span>
            </div>
          </li>
          @if (userDetailsData?.enrollmentType === 'Company') {
          <li class="mb-1">
            <div class="menu-row d-flex align-items-center"(click)="toggleMenu('inventory')">
              <span class="menu-row"></span>
              <span [routerLink]="'/admin/inventory'" routerLinkActive="active" class="heading-text" style="cursor: pointer;" #collapse data-menu="inventory"
              >&nbsp;Inventory</span>
            </div>
          </li>
          }
        </ul>
      }
      <ul class="list-unstyled ps-0">
        <li class="mb-1">
          <div class="menu-row d-flex align-items-center" (click)="toggleMenu('admin')">
            <fa-icon [icon]="open.admin ? faAngleDown : faAngleRight" class="toggle-icon"></fa-icon>
            <span class="heading-text rounded">&nbsp;Administration</span>
          </div>
          <div class="collapse" id="admin-collapse" #collapse data-menu="admin">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              @if (authService.isAdmin()) {
                <li>
                  <a [routerLink]="'/admin/sdex/company'" class="nav-link align-middle pointer-event heading-text"
                    [ngClass]="{'active': isMenuItemActive(1)}" (click)="setSelectedMenuItem(1)">
                    <span class="heading-text rounded">Companies</span>
                  </a>
                </li>
              }
              <li>
                <a [routerLink]="'/admin/users'" routerLinkActive="active" class="heading-text rounded"[ngClass]="{'active': isMenuItemActive(2)}"
                (click)="setSelectedMenuItem(2)">Users</a>
              </li>
              @if (userDetailsData?.enrollmentType === 'Company') {
              <li>
                <a [routerLink]="'/sku-merge'" routerLinkActive="active" class="heading-text rounded"
                  [ngClass]="{'active': isMenuItemActive(29)}" (click)="setSelectedMenuItem(29)">Merge SKUs</a>
              </li>
              }
              @if (
                !authService.isAdmin() &&
                this.userDetailsData?.company ===
                this.userDetailsData?.rootCompany
                ) {
                <li>
                </li>
              }
            </ul>
          </div>
        </li>
      </ul>
      @if (userDetailsData?.enrollmentType === 'Company') {
        <ul class="list-unstyled ps-0">
          <li class="mb-1">
            <div class="menu-row d-flex align-items-center" (click)="toggleMenu('branches')">
              <fa-icon [icon]="open.branches ? faAngleDown : faAngleRight" class="toggle-icon"></fa-icon>
              <span class="heading-text">&nbsp;Branches</span>
            </div>
            <div class="collapse" id="branches-collapse" #collapse data-menu="branches">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                <li>
                  <a [routerLink]="['admin/sub-company-users']" routerLinkActive="active" class="heading-text rounded"
                  [ngClass]="{'active': isMenuItemActive(3)}" (click)="setSelectedMenuItem(3)"> Branch Users</a>
                </li>
                <li>
                  <a [routerLink]="['admin/company']" class="heading-text rounded"
                  [ngClass]="{ 'active': activeItem === 'branch-list' }">Branch List</a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      }
      @if (!authService.isAdmin()) {
        <ul class="list-unstyled ps-0">
          <li class="mb-1">
            <div class="menu-row d-flex align-items-center">
              <span class="menu-row"></span>
              <span [routerLink]="'/dealer-list'" class="heading-text" style="cursor: pointer;"
              #collapse data-menu="dealer-list" [ngClass]="{ 'active': activeItem === 'dealer-list' }"
              (click)="setSelectedMenuItem(6)">&nbsp;Dealers</span>
            </div>
          </li>
          <li class="mb-1">
            <div class="menu-row d-flex align-items-center">
              <span class="menu-row"></span>
              <span [routerLink]="'/product-list'" class="heading-text" style="cursor: pointer;"
                #collapse data-menu="product-list" [ngClass]="{ 'active': activeItem === 'product-list' }"
                (click)="setSelectedMenuItem(8)">&nbsp;Purchase</span>
            </div>
          </li>
        </ul>
      }
      @if (!authService.isAdmin()) {
        <ul class="list-unstyled ps-0">
          <li class="mb-1">
            <div class="menu-row d-flex align-items-center" (click)="toggleMenu('sales')">
              <fa-icon [icon]="open.sales? faAngleDown : faAngleRight" class="toggle-icon"></fa-icon>
              <span class="heading-text">&nbsp;Sales and Services</span>
            </div>
            <div class="collapse" id="sales-collapse" #collapse data-menu="sales">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                <li>
                  <a [routerLink]="'/order-out'" routerLinkActive="active" class="heading-text rounded" [ngClass]="{'active': isMenuItemActive(10)}"
                  (click)="setSelectedMenuItem(10)">Sale to Customer</a>
                </li>
                <li>
                  <a [routerLink]="'/sale-to-dealer'" routerLinkActive="active" class="heading-text rounded" [ngClass]="{'active': isMenuItemActive(23)}"
                  (click)="setSelectedMenuItem(23)">Sale to Dealer</a>
                </li>
                <li>
                  <a [routerLink]="'/transfer-to-branch'" routerLinkActive="active" class="heading-text rounded"
                  [ngClass]="{'active': isMenuItemActive(9)}" (click)="setSelectedMenuItem(9)">Transfer to Branch</a>
                </li>
                <li>
                  <a [routerLink]="'/service-entry'" routerLinkActive="active" class="heading-text rounded"
                  [ngClass]="{'active': isMenuItemActive(15)}" (click)="setSelectedMenuItem(15)">Service Entry</a>
                </li>
                <li>
                  <a [routerLink]="'/order-list'"  routerLinkActive="active" class="heading-text rounded" [ngClass]="{'active': isMenuItemActive(11)}"
                  (click)="setSelectedMenuItem(11)">Sales List</a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      }
      @if (!authService.isAdmin()) {
        <ul class="list-unstyled ps-0">
          <li class="mb-1">
            <div class="menu-row d-flex align-items-center" (click)="toggleMenu('returns')">
              <fa-icon [icon]="open.returns ? faAngleDown : faAngleRight" class="toggle-icon"></fa-icon>
              <span class="heading-text">&nbsp;Returns</span>
            </div>
            <div class="collapse" id="returns-collapse" #collapse data-menu="returns">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                <li>
                  <a [routerLink]="'/return-to-dealer'" routerLinkActive="active" class="heading-text rounded"
                  [ngClass]="{'active': isMenuItemActive(12)}" (click)="setSelectedMenuItem(12)">Return to Dealer</a>
                </li>
                <li>
                  <a [routerLink]="'/return-from-customer'" routerLinkActive="active" class="heading-text rounded"
                  [ngClass]="{'active': isMenuItemActive(13)}" (click)="setSelectedMenuItem(13)">Return from Customer</a>
                </li>
                <li>
                  <a [routerLink]="'/return-and-replace'" routerLinkActive="active" class="heading-text rounded"
                  [ngClass]="{'active': isMenuItemActive(14)}" (click)="setSelectedMenuItem(14)">Exchange</a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      }
      @if (!authService.isAdmin()) {
        <ul class="list-unstyled ps-0">
          <li class="mb-1">
            <div class="menu-row d-flex align-items-center" (click)="toggleMenu('ledger')">
              <fa-icon [icon]="open.ledger ? faAngleDown : faAngleRight" class="toggle-icon"></fa-icon>
              <span class="heading-text">&nbsp;Ledgers</span>
            </div>
            <div class="collapse" id="ledger-collapse" #collapse data-menu="ledger">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                <li>
                  <a [routerLink]="'/sku-ledger'" routerLinkActive="active" class="heading-text rounded"
                  [ngClass]="{'active': isMenuItemActive(26)}" (click)="setSelectedMenuItem(26)">SKU Ledger</a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      }
      @if(!authService.isAdmin()) {
        <ul class="list-unstyled ps-0">
          <li class="mb-1">
            <div class="menu-row d-flex align-items-center" (click)="toggleMenu('accounts')">
              <fa-icon [icon]="open.accounts ? faAngleDown : faAngleRight" class="toggle-icon"></fa-icon>
              <span class="heading-text">&nbsp;Accounts</span>
            </div>
            <div class="collapse" id="accounts-collapse" #collapse data-menu="accounts">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                @if(userDetailsData?.enrollmentType === 'Company') {
                <li>
                  <a [routerLink]="'/balance-account'" routerLinkActive="active" class="heading-text rounded"
                    [ngClass]="{'active': isMenuItemActive(30)}" (click)="setSelectedMenuItem(30)">Balance Accounts</a>
                </li>
                }
                <li>
                  <a [routerLink]="'/payments-account'" routerLinkActive="active" class="heading-text rounded"
                    [ngClass]="{'active': isMenuItemActive(27)}" (click)="setSelectedMenuItem(27)">Payment Accounts</a>
                </li>
                @if(userDetailsData?.enrollmentType === 'Company') {
                <li>
                  <a [routerLink]="'/settlements'" routerLinkActive="active" class="heading-text rounded"
                    [ngClass]="{'active': isMenuItemActive(31)}" (click)="setSelectedMenuItem(31)">Settlements</a>
                </li>
                }
              </ul>
            </div>
          </li>
        </ul>
      }
      <ul class="list-unstyled ps-0">
        <li class="mb-1">
          <div class="menu-row d-flex align-items-center"  (click)="toggleMenu('master')">
            <fa-icon [icon]="open.master ? faAngleDown : faAngleRight" class="toggle-icon"></fa-icon>
            <span class="heading-text">&nbsp;Master Data Details</span>
          </div>
          <div class="collapse" id="master-collapse" #collapse data-menu="master">
            <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
              <li>
                <a [routerLink]="'/master-data-list'" class="heading-text rounded"
                [ngClass]="{'active': activeItem === 'tyre-size' }">Tyre Size</a>
              </li>
              @if (!authService.isAdmin()) {
                <li>
                  <a [routerLink]="'/master-data'" routerLinkActive="active" class="heading-text rounded"
                  [ngClass]="{'active': isMenuItemActive(24)}" (click)="setSelectedMenuItem(24)">Services</a>
                </li>
              }
              @if (authService.isAdmin()) {
                <li>
                  <a [routerLink]="'/tyre-model-list'" routerLinkActive="active" class="heading-text rounded"
                  [ngClass]="{'active': isMenuItemActive(18)}" (click)="setSelectedMenuItem(18)">Tyre Pattern</a>
                </li>
              }
              @if (authService.isAdmin()) {
                <li>
                  <a [routerLink]="'/pending-tyre-pattern'" routerLinkActive="active" class="heading-text rounded"
                  [ngClass]="{'active': isMenuItemActive(25)}" (click)="setSelectedMenuItem(25)">Pending Tyre Pattern</a>
                </li>
              }
              @if (authService.isAdmin()) {
                <li>
                  <a [routerLink]="'/tyre-brand-list'" routerLinkActive="active" class="heading-text rounded"
                  [ngClass]="{'active': isMenuItemActive(19)}" (click)="setSelectedMenuItem(19)">Tyre Brand</a>
                </li>
              }
              @if (authService.isAdmin()) {
                <li>
                  <a [routerLink]="'/vehicle-model-list'" routerLinkActive="active" class="heading-text rounded"
                  [ngClass]="{'active': isMenuItemActive(20)}" (click)="setSelectedMenuItem(20)">Vehicle Model</a>
                </li>
              }
              @if (authService.isAdmin()) {
                <li>
                  <a [routerLink]="'/vehicle-make-list'" routerLinkActive="active" class="heading-text rounded"
                  [ngClass]="{'active': isMenuItemActive(21)}" (click)="setSelectedMenuItem(21)">Vehicle Make</a>
                </li>
              }
              @if (!authService.isAdmin()) {
                <li>
                  <a [routerLink]="'/expense-categories'" routerLinkActive="active" class="heading-text rounded"
                  [ngClass]="{'active': isMenuItemActive(28)}" (click)="setSelectedMenuItem(28)">Expense Categories</a>
                </li>
              }
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>